/**
 * Asset Edit Modal component
 */

import { useEffect, useRef } from 'react'
import { AssetForm } from './AssetForm'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { GoldAsset } from '@/types/asset'

interface AssetEditModalProps {
  asset: GoldAsset
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
}

export function AssetEditModal({ asset, isOpen, onClose, onSuccess }: AssetEditModalProps) {
  const firstInputRef = useRef<HTMLInputElement>(null)

  const handleSuccess = () => {
    onSuccess()
    onClose()
  }

  // Auto-focus first input on modal open
  useEffect(() => {
    if (isOpen && firstInputRef.current) {
      // Small delay to ensure dialog is fully rendered
      setTimeout(() => {
        firstInputRef.current?.focus()
      }, 100)
    }
  }, [isOpen])

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Sửa tài sản</DialogTitle>
        </DialogHeader>
        <AssetForm 
          asset={asset} 
          onSuccess={handleSuccess} 
          onCancel={onClose}
          firstInputRef={firstInputRef}
        />
      </DialogContent>
    </Dialog>
  )
}

